import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

// configs
import { API } from 'configs/api';
// components
import { errorToast } from 'components/toasts/error';

export const videoSecurityAuthMutation = async ({
  shortUrl,
  password,
}: {
  shortUrl: string | undefined;
  password?: string;
}) => {
  // CHANGE THIS ROUTE WHEN NEW API IS READY
  const response: AxiosResponse = await API.post(
    `/playback/${shortUrl}/security`,
    {
      password,
    }
  );

  return response.data;
};

export const useVideoSecurityAuthMutation = ({
  setPasswordVerified,
}: {
  setPasswordVerified: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return useMutation(videoSecurityAuthMutation, {
    onSuccess: () => {
      setPasswordVerified(true);
    },
    onError: () => {
      errorToast({ title: 'Invalid password' });
    },
  });
};
